import React, { useEffect, useMemo, useState } from 'react';
import { Card, CardContent } from '@web/components/ui/card';
import { trpc } from '@web/lib/trpc';
import ContractTable from './ContractTable';
import { Button } from '@web/components/ui/button';
import { Spinner } from '@web/components/ui/spinner';

export default function Contracts({ contactId }: { contactId: string }) {
  const [paginationLimit, setPaginationLimit] = useState(10);
  const [showButton, setShowButton] = useState(true);

  const {
    data: contractsData,
    isFetching,
    fetchNextPage,
  } = trpc.contracts.listAllWithLimit.useInfiniteQuery(
    {
      limit: paginationLimit,
      contactId: contactId,
    },
    {
      getNextPageParam: (lastPage) => ({
        contractId: lastPage.at(-1)?.id ?? '',
      }),
    },
  );

  const allContracts = useMemo(
    () => contractsData?.pages.flatMap((page) => page) ?? [],
    [contractsData],
  );

  useEffect(() => {
    if (allContracts.length < paginationLimit) {
      setShowButton(false);
    } else {
      setShowButton(true);
    }
  }, [contractsData]);

  const LoadMoreHandler = async () => {
    setPaginationLimit((limit) => limit + 10);
    await fetchNextPage();
  };

  return (
    <Card className="overflow-hidden rounded-xl border-2 p-0 shadow-2xl">
      <CardContent className="p-2">
        <ContractTable contracts={allContracts} />

        {!allContracts.length && (
          <Card className="mt-2 border-2 p-0">
            <CardContent className="text-center">
              <p className="font-bold text-gray-800 dark:text-gray-200">
                No contracts yet.
              </p>
            </CardContent>
          </Card>
        )}
      </CardContent>

      {showButton && (
        <div className="flex w-full justify-end p-6">
          <Button
            className="rounded p-4"
            onClick={() => {
              void LoadMoreHandler();
            }}
          >
            {isFetching ? <Spinner /> : 'Load More'}
          </Button>
        </div>
      )}
    </Card>
  );
}
